import { Box, Button } from '@mui/material';
import { useEffect, useState } from 'react';
import { PageHeading } from '../../../../../shared/lib/common/PageHeading';
import { GET_STARTED } from '../../../../../shared/lib/constants';
import { withTrademark } from '../../../../../shared/lib/common/Tokenizer';
import palette from '../../../../../shared/lib/theme/palette';
import { images } from '../../../../../shared/lib/assets';
import { BeforeStepperContentWrapper, BeforeStepperContentWrapperMobile, getStartedMobileLogo, getStartedMobileLogoWrapper } from '../../../../../shared/lib/theme/styleConstants';
import { OnBoardingStepper } from '../../../components/OnBoardingStepper';
import { AuthContainer } from '../../../components/auth/AuthContainer';
import { useAppContext } from '../../contexts/AppContext';
import PendingPromoAlert from '../../../components/common/PendingPromoAlert';
import { useMobileView } from '../../hooks/useMobileView';

const OnBoarding = () => {
  const [showStepper, setShowStepper] = useState<boolean>(false);
  const { currentUser } = useAppContext();
  const { phoneNumber, isSubscribed, isTPinAdded } = currentUser || {};
  const { blackOne } = palette;
  const { customerStripeId } = isSubscribed || {};

  const goToStepper = () => {
    setShowStepper(true);
  };

  useEffect(() => {
    if (phoneNumber || customerStripeId || isTPinAdded) {
      setShowStepper(true);
    }
  }, [phoneNumber, customerStripeId, isTPinAdded]);

  const mediumViewport = useMobileView();

  return (
    <AuthContainer onBoarding>
      <Box position="relative" flex={1}>
        {showStepper ? (
          <OnBoardingStepper />
        ) : (
          <Box sx={mediumViewport ? BeforeStepperContentWrapperMobile : BeforeStepperContentWrapper}>
            <Box width={mediumViewport ? '100%' : '500px'} textAlign='center' paddingX={'20px'} >
              {mediumViewport && (
                <Box sx={getStartedMobileLogoWrapper}>
                  <Box component="img" sx={getStartedMobileLogo} src={images.MOBILE_AUTH_LOGO as unknown as string} alt="855WhoDoICall logo" />
                </Box>
              )}

              <PendingPromoAlert />

              <PageHeading color={blackOne} title={withTrademark(GET_STARTED.TITLE)} subTitle={GET_STARTED.DESCRIPTION} />

              <Button onClick={goToStepper} variant="contained" fullWidth>
                {GET_STARTED.BUTTON}
              </Button>
            </Box>
          </Box>
        )}
      </Box>
    </AuthContainer>
  );
};

export default OnBoarding;
